import { IClient } from 'client/IClientInfo'
import { IStatusResponce } from 'HttpRequests'

interface IRegisterResponse {
  status: string
  user_id?: number
}

interface ILoginResponse {
  status: string
  tries?: number
  user?: IClient
  is_first_login?: boolean
}

function formURL(url: string): URL {
  if (url[0] !== '/') return new URL(window.location.origin + '/' + url)
  return new URL(window.location.origin + url)
}

function _specialReqPost(
  url: string,
  data: object,
  callback: (response: any) => void,
  onError: (error: string) => void
) {
  fetch(formURL(url).toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
    })
    .then((data) => {
      if (data) {
        callback(data)
      }
    })
    .catch((e) => {
      onError('Сервер временно недоступен')
      console.log('No server response. ' + e)
    })
}

const _specialReqGet = (
  url: string,
  callback: (response: any) => void,
  onError: (status: string) => void
) => {
  let is_call_callback = true
  let url_ = formURL(url).toString()
  fetch(url_, {
    method: 'GET',
    // headers: { 'x-acceass-token': token },
  })
    .then((response) => {
      if (!response.ok) {
        if (response.statusText === 'UNAUTHORIZED' || response.status === 401) {
          is_call_callback = false
          onError('Время сеанса истекло')
        } else {
          throw Error(response.statusText)
        }
      }

      return response.json()
    })
    .then((data) => {
      if (is_call_callback) {
        callback(data)
      }
    })
    .catch((e) => {
      console.log('No server response. ' + e + '\n', 'callbak: ', callback)
      onError('Сервер временно недоступен')
    })
}

function reqLogin(
  loginPhone: string,
  password: string,
  isRemember: boolean,
  captcha: string,
  captchaHash: string,
  callback: (response: ILoginResponse) => void
) {
  _specialReqPost(
    'api/login/',
    {
      loginPhone,
      password,
      isRemember,
      captcha,
      captchaHash
    },
    callback,
    (error) => {
      callback({ status: error })
    }
  )
}

function reqLoginViaCookie(callback: (response: ILoginResponse) => void) {
  _specialReqGet('api/login_with_cookie/', callback, (error) => {
    callback({ status: error })
  })
}

function reqLogout(callback: (response: ILoginResponse) => void) {
  _specialReqGet('api/logout/', callback, (error) => {
    callback({ status: error })
  })
}

function reqRegister(
  name: string,
  phoneNumber: string,
  email: string,
  password: string,
  secondPassword: string,
  captcha: string,
  captchaHash: string,
  callback: (response: IRegisterResponse) => void
) {
  _specialReqPost(
    'api/register/',
    {
      name,
      phoneNumber,
      email,
      password,
      secondPassword,
      captcha,
      captchaHash,
    },
    callback,
    (error) => {
      callback({ status: error })
    }
  )
}

function reqEnterRegisterCode(
  userId: number,
  code: number,
  isRemember: boolean,
  callback: (response: ILoginResponse) => void
) {
  _specialReqPost(
    'api/enter_register_code/',
    {
      userId,
      code,
      isRemember,
    },
    callback,
    (error) => {
      callback({ status: error })
    }
  )
}

function reqSendRecoveryCode(
phoneNumber: string, captcha: string, captchaHash: string, callback: (response: IStatusResponce) => void) {
  _specialReqPost(
    'api/send_recovery_code/',
    {
      phoneNumber,
      captcha,
      captchaHash
    },
    callback,
    (error) => {
      callback({ status: error })
    }
  )
}

function reqChangePasswordWithCode(
  phoneNumber: string,
  code: number,
  password: string,
  secondPassword: string,
  callback: (response: IStatusResponce) => void
) {
  _specialReqPost(
    'api/change_pswd_with_code/',
    {
      phoneNumber,
      code,
      password,
      secondPassword,
    },
    callback,
    (error) => {
      callback({ status: error })
    }
  )
}

export {
  reqLogin,
  reqLogout,
  reqLoginViaCookie,
  reqRegister,
  reqEnterRegisterCode,
  reqSendRecoveryCode,
  reqChangePasswordWithCode,
}
